export default "__VITE_ASSET__BRbHrBRf__"